// Helpers da empresa ativa (multi-CNPJ) para componentes que leem o localStorage
// direto (heartbeat, grupos SignalR etc). A fonte da verdade é localStorage.empresaAtiva,
// gravada pela mutation setEmpresaAtiva; ausente = opera como o titular.

// Empresa ativa selecionada, ou null quando operando como titular
export function getEmpresaAtiva() {
    try {
        return JSON.parse(localStorage.getItem('empresaAtiva') || 'null');
    } catch {
        return null;
    }
}

// CNPJ que deve contextualizar as ações do dia a dia (empresa ativa ou titular)
export function getCnpjAtivo() {
    const empresa = getEmpresaAtiva();
    if (empresa?.cnpj) return empresa.cnpj;
    const user = JSON.parse(localStorage.getItem('userDados') || 'null');
    return user?.cnpj || '';
}

// Remove a seleção (logout / vínculo inválido)
export function limpaEmpresaAtiva() {
    localStorage.removeItem('empresaAtiva');
}
